const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const resolveBaseUrl = (...candidates) => {
  for (const candidate of candidates) {
    const normalized = String(candidate || "").trim();
    if (normalized) {
      return trimTrailingSlash(normalized);
    }
  }
  return "";
};

export const CHAT_DB_SERVER_URL = resolveBaseUrl(
  import.meta.env.VITE_CHAT_DB_SERVER_URL,
  "http://localhost:8010"
);

export const PAYMENTS_SERVER_URL = resolveBaseUrl(
  import.meta.env.VITE_PAYMENTS_SERVER_URL,
  "http://localhost:4001"
);

export const NOTIFY_URL = String(import.meta.env.VITE_NOTIFY_URL || "").trim();
